import React, { useState } from 'react';

const tiers = [
  {
    key: 'practice',
    label: 'Free Agent',
    accent: 'border-[#00aef7]',
    image: 'Whistle.png',
    imageSize: 'w-12 h-12',
    monthly: 0,
    annual: 0,
    features: [
      'Design 1 business creation for sharing to Social Media or by email, per month',
      'Share other users business creations to your channels and by email',
      'Other users can share your business creations to their channels and by email',
      'Unlimited sharing of others business creations to your channels',
      'Research teams and discover potential teammates',
      'Meet your local business neighbors',
      'Share to your personal social channels',
    ],
  },
  {
    key: 'first',
    label: 'First String',
    accent: 'border-[#44d0b7]',
    image: 'Foam_Finger.png',
    imageSize: 'w-12 h-12',
    monthly: 19.99,
    annual: 215.89,
    features: [
      'Design 5 business creations for sharing to Social Media or by email, per month',
      'Unlimited Trusted Review requests',
      'Respond publicly to customer reviews',
      'Design up to 10 Social Media posts per month',
      'Share to all connected social platforms',
      'Access community events and local networking',
      'Priority placement in team search results',
      'Basic analytics on your review performance',
    ],
  },
  {
    key: 'allstar',
    label: 'All-Star',
    accent: 'border-amber-300',
    image: 'gold_star.png',
    imageSize: 'w-12 h-12',
    monthly: 49.99,
    annual: 539.89,
    features: [
      'Everything in First String',
      'Unlimited Social Media post designs',
      'Schedule and auto-publish to all platforms',
      'Advanced reputation analytics and insights',
      'Showcase your best reviews on your profile',
      'Join and create community groups',
      'Enhanced visibility in local business directory',
      'Custom branding on shared content',
    ],
  },
  {
    key: 'captain',
    label: 'Team Captain',
    accent: 'border-red-300',
    image: 'Captain.png',
    imageSize: 'w-12 h-12',
    monthly: 0,
    annual: 0,
    isCaptain: true,
    features: [
      'Build a team and earn $5/mo credit per member',
      'Everything in First String included',
      'Recruit and manage your team',
      '4 members = your subscription is free',
      'Team performance dashboards',
      'Onboard new members with guided setup',
      'Community leadership recognition badge',
      'Shape the platform as a founding captain',
    ],
  },
];

export default function PricingPage() {
  const [billing, setBilling] = useState('monthly');

  const formatPrice = (tier) => {
    const price = billing === 'monthly' ? tier.monthly : tier.annual;
    if (tier.isCaptain) return 'Free*';
    if (price === 0) return 'Free';
    return `$${price.toFixed(2)}`;
  };

  const priceLabel = (tier) => {
    const price = billing === 'monthly' ? tier.monthly : tier.annual;
    if (price === 0 && !tier.isCaptain) return '';
    if (tier.isCaptain) return '';
    return billing === 'monthly' ? '/mo' : '/yr';
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="pt-[5px] pb-2">
        <div className="mx-auto w-[90%]">
          {/* Toggle */}
          <div className="flex justify-center">
            <div className="inline-flex items-center rounded-full border border-gray-200 bg-white shadow-sm p-1">
              <button
                type="button"
                onClick={() => setBilling('monthly')}
                className={[
                  'px-6 py-2 rounded-full text-sm font-semibold transition-colors',
                  billing === 'monthly'
                    ? 'bg-brand text-white'
                    : 'text-gray-700 hover:text-brand',
                ].join(' ')}
              >
                Monthly
              </button>
              <button
                type="button"
                onClick={() => setBilling('annual')}
                className={[
                  'px-6 py-2 rounded-full text-sm font-semibold transition-colors',
                  billing === 'annual'
                    ? 'bg-brand text-white'
                    : 'text-gray-700 hover:text-brand',
                ].join(' ')}
              >
                Annual
              </button>
            </div>
          </div>

          {/* Cards row */}
          <div className="mt-2">
            <div className="flex flex-col gap-4 md:flex-row md:gap-3 md:justify-between">
              {tiers.map((t) => (
                <div key={t.key} className="w-full md:flex-1 md:min-w-0">
                  <div
                    className={[
                      'relative bg-white rounded-[32px]',
                      'border-4',
                      t.accent,
                      'shadow-[0_10px_30px_rgba(0,0,0,0.12)]',
                      'overflow-hidden',
                      'md:h-[450px]',
                      'flex flex-col',
                    ].join(' ')}
                  >
                    {/* header */}
                    <div className="px-4 pt-1 flex flex-col items-center shrink-0">
                      <img
                        src={`${process.env.PUBLIC_URL}/pricing/${t.image}`}
                        alt={t.label}
                        className={`${t.imageSize} object-contain`}
                        draggable="false"
                      />
                      <div className="mt-2 text-xl font-bold text-gray-900 text-center whitespace-nowrap">
                        {t.label}
                      </div>

                      {/* price */}
                      <div className="mt-1 flex items-baseline gap-1">
                        <span className="text-2xl font-extrabold text-gray-900">
                          {formatPrice(t)}
                        </span>
                        <span className="text-sm text-gray-500">
                          {priceLabel(t)}
                        </span>
                      </div>
                    </div>

                    {/* divider */}
                    <div className="mx-4 mt-2 border-t border-gray-200" />

                    {/* feature list */}
                    <div className="px-4 pt-2 pb-4 overflow-y-auto flex-1 scrollbar-thin scrollbar-thumb-gray-200 scrollbar-track-transparent">
                      <ul className="space-y-1.5">
                        {t.features.map((f, i) => (
                          <li key={i} className="flex items-start gap-2 text-xs text-gray-700">
                            <span className="mt-0.5 shrink-0 text-green-500">✓</span>
                            <span>{f}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
